
import React from 'react';
import { Button } from '@/components/ui/button';
import { Droplets, Plus, Minus } from 'lucide-react';
import { useFasting } from '@/contexts/FastingContext';
import { Badge } from '@/components/ui/badge';

export const WaterIntakeTracker: React.FC = () => {
  const { waterIntake, increaseWaterIntake, decreaseWaterIntake } = useFasting();
  
  const getHydrationStatus = () => {
    if (waterIntake >= 12) return { status: 'Wow!', color: 'bg-purple-500' };
    if (waterIntake >= 8) return { status: 'Excellent', color: 'bg-green-500' };
    if (waterIntake >= 5) return { status: 'Good', color: 'bg-fasttrack-blue' };
    if (waterIntake >= 3) return { status: 'Fair', color: 'bg-yellow-500' };
    return { status: 'Low', color: 'bg-red-500' };
  };
  
  const getEasterEggMessage = () => {
    if (waterIntake >= 20) return "You're practically a fish! 🐠";
    if (waterIntake >= 16) return "Holy hydration! 💦";
    if (waterIntake >= 12) return "Incredible! 🌊";
    return "";
  };
  
  const hydrationStatus = getHydrationStatus();
  const easterEggMessage = getEasterEggMessage();
  
  return (
    <div className="p-4 border rounded-lg border-fasttrack-light-blue/30 mb-4 relative">
      <Badge variant="outline" className={`${hydrationStatus.color} text-white absolute top-2 right-2`}>
        {hydrationStatus.status}
      </Badge>
      
      <h3 className="text-lg font-semibold text-fasttrack-blue mb-2 flex items-center">
        <Droplets className="mr-2" size={20} />
        Water Intake Tracker
      </h3>
      
      <div className="flex justify-between items-center">
        <div>
          <p className="text-sm text-muted-foreground mb-1">How many cups of water today?</p>
          {easterEggMessage && (
            <p className="text-xs text-purple-500 font-medium animate-pulse">{easterEggMessage}</p>
          )}
        </div>
        
        <div className="flex items-center space-x-2">
          <Button 
            variant="outline" 
            size="sm"
            onClick={decreaseWaterIntake}
            disabled={waterIntake <= 0}
            className="h-8 w-8 p-0 flex items-center justify-center"
          >
            <Minus size={16} />
          </Button>
          
          <div className="w-8 flex justify-center">
            <span className="text-lg font-bold text-fasttrack-blue">{waterIntake}</span>
          </div>
          
          <Button 
            variant="outline" 
            size="sm"
            onClick={increaseWaterIntake}
            className="h-8 w-8 p-0 flex items-center justify-center border-fasttrack-blue text-fasttrack-blue hover:bg-fasttrack-blue/10"
          >
            <Plus size={16} />
          </Button>
        </div>
      </div>
    </div>
  );
};
